import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { ArrowRight, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useReaderAuth } from "@/contexts/ReaderAuthContext";

export default function ReaderLoginPage() {
    const { login } = useReaderAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const [params] = useSearchParams();
    const nav = useNavigate();
    const redirect = params.get("redirect") || "/extra";

    const submit = async (e) => {
        e.preventDefault();
        if (!email || !password) return;
        setBusy(true);
        try {
            await login(email, password);
            toast.success("Accesso effettuato");
            nav(redirect, { replace: true });
        } catch (err) {
            toast.error(err.message || "Errore accesso");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="max-w-md mx-auto mt-4 md:mt-10">
            <h1 className="pvx-serif text-3xl tracking-tight mb-2">Accedi ai contenuti extra</h1>
            <p className="text-[13.5px] text-pvx-textmuted mb-8">
                Accedi con la tua email per sbloccare i contenuti collegati ai libri Prime Vision.
            </p>
            <form onSubmit={submit} className="pvx-card p-6 md:p-7 space-y-4" data-testid="reader-login-form">
                <div>
                    <label className="pvx-eyebrow mb-1.5 block">Email</label>
                    <input
                        data-testid="reader-login-email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="w-full h-10 px-3 rounded-[10px] border border-pvx-border bg-pvx-surface/60 focus:bg-pvx-surface focus:border-pvx-primary/50 text-[13.5px] outline-none transition-colors"
                        autoComplete="email"
                    />
                </div>
                <div>
                    <label className="pvx-eyebrow mb-1.5 block">Password</label>
                    <input
                        data-testid="reader-login-password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        className="w-full h-10 px-3 rounded-[10px] border border-pvx-border bg-pvx-surface/60 focus:bg-pvx-surface focus:border-pvx-primary/50 text-[13.5px] outline-none transition-colors"
                        autoComplete="current-password"
                    />
                </div>

                <button
                    data-testid="reader-login-submit"
                    type="submit"
                    disabled={busy}
                    className="w-full flex items-center justify-center gap-2 bg-pvx-primary text-white rounded-[10px] py-2.5 text-[13.5px] font-medium hover:opacity-90 disabled:opacity-60 transition-opacity"
                >
                    {busy ? <Loader2 size={14} strokeWidth={1.5} className="animate-spin" /> : null}
                    Entra
                    {!busy && <ArrowRight size={14} strokeWidth={1.5} />}
                </button>

                <div className="pvx-divider" />

                <div className="flex justify-between text-[12.5px]">
                    <Link to="/reader/forgot" className="text-pvx-textmuted hover:text-pvx-primary transition-colors">Password dimenticata?</Link>
                    <Link to={`/reader/register${redirect !== "/extra" ? `?redirect=${encodeURIComponent(redirect)}` : ""}`} className="text-pvx-primary font-medium hover:underline">Non hai un account? Registrati</Link>
                </div>
            </form>
        </div>
    );
}
